import { NavLink as ReactRouterNavLink } from 'react-router-dom';
export function NavLink({ to, text }: any) {
  return (
    <ReactRouterNavLink
      to={to}
      className={({ isActive }) =>
        isActive
          ? 'hover:text-foreground'
          : 'text-muted-foreground hover:text-foreground'
      }
    >
      {text}
    </ReactRouterNavLink>
  );
}
